var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_937_16953",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1H1V13C1 19.6274 6.37258 25 13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1ZM13 20C12.4477 20 12 19.5523 12 19V14H7C6.44772 14 6 13.5523 6 13C6 12.4477 6.44772 12 7 12H12V7C12 6.44771 12.4477 6 13 6C13.5523 6 14 6.44771 14 7V12H19C19.5523 12 20 12.4477 20 13C20 13.5523 19.5523 14 19 14H14V19C14 19.5523 13.5523 20 13 20Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1H1V13C1 19.6274 6.37258 25 13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1ZM13 20C12.4477 20 12 19.5523 12 19V14H7C6.44772 14 6 13.5523 6 13C6 12.4477 6.44772 12 7 12H12V7C12 6.44771 12.4477 6 13 6C13.5523 6 14 6.44771 14 7V12H19C19.5523 12 20 12.4477 20 13C20 13.5523 19.5523 14 19 14H14V19C14 19.5523 13.5523 20 13 20Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V0H0V1H1ZM12 14H13V13H12V14ZM12 12V13H13V12H12ZM14 12H13V13H14V12ZM14 14V13H13V14H14ZM1 2H13V0H1V2ZM2 13V1H0V13H2ZM13 24C6.92487 24 2 19.0751 2 13H0C0 20.1797 5.8203 26 13 26V24ZM24 13C24 19.0751 19.0751 24 13 24V26C20.1797 26 26 20.1797 26 13H24ZM13 2C19.0751 2 24 6.92487 24 13H26C26 5.8203 20.1797 0 13 0V2ZM11 19C11 20.1046 11.8954 21 13 21V19H11ZM11 14V19H13V14H11ZM7 15H12V13H7V15ZM5 13C5 14.1046 5.89543 15 7 15V13H5ZM7 11C5.89543 11 5 11.8954 5 13H7V11ZM12 11H7V13H12V11ZM11 7V12H13V7H11ZM13 5C11.8954 5 11 5.89543 11 7H13V5ZM15 7C15 5.89543 14.1046 5 13 5V7H15ZM15 12V7H13V12H15ZM19 11H14V13H19V11ZM21 13C21 11.8954 20.1046 11 19 11V13H21ZM19 15C20.1046 15 21 14.1046 21 13H19V15ZM14 15H19V13H14V15ZM15 19V14H13V19H15ZM13 21C14.1046 21 15 20.1046 15 19H13V21Z",
    fill: "white",
    mask: "url(#path-1-outside-1_937_16953)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCursor);
export default __webpack_public_path__ + "static/media/markerCursor.2a61c3bea72667e7ab024ddf93a62604.svg";
export { ForwardRef as ReactComponent };